<template>
  <span>
    <v-btn x-small icon class="btn-checkbox" @click="_onClick">
      <v-icon x-small :color="value ? '' : 'blue'">
        fas
        {{ value ? 'fa-eye-slash' : 'fa-eye' }}
      </v-icon>
    </v-btn>

    <span v-if="label" :class="'small-text ' + (hidden ? 'hidden' : '')">
      {{ label }}
    </span>
  </span>
</template>

<script>
export default {
  props: {
    label: String,
    value: Boolean,
    onClick: Function,
    hidden: [Boolean, Number],
  },

  methods: {
    _onClick() {
      if (this.onClick) {
        this.onClick();
      }
    },
  },
};
</script>

<style scoped>
.btn-checkbox {
  width: auto !important;
}
.small-text {
  font-size: 80%;
}
.hidden {
  color: var(--v-foreground-base);
}
</style>